<div class="layout {{routeData?.layout}}">
  <formio id="formio"></formio>
  <div hidden id="spinner"></div>
</div>
